<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Tiktok" class="d-icon d-icon--tiktok" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g clip-rule="evenodd" fill-rule="evenodd"><path d="M2 17a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5V7a5 5 0 0 0-5-5H7a5 5 0 0 0-5 5z" fill="currentColor"/><path d="M14.765 4.62a3.846 3.846 0 0 1-.12-.953h-2.903v10.888c0 1.256-.857 2.274-2.11 2.274s-2.267-1.018-2.267-2.273a2.27 2.27 0 0 1 2.268-2.274c.25 0 .332.04.557.116V9.46c-.235-.033-.315-.05-.557-.05A5.14 5.14 0 0 0 4.5 14.556a5.14 5.14 0 0 0 5.133 5.146c2.795 0 5.148-2.24 5.212-5.026V9.104c1.053.722 2.248 1.144 3.62 1.144V7.496a3.822 3.822 0 0 1-3.7-2.876z" fill="#25f4ee"/><path d="M15.8 5.654a3.85 3.85 0 0 1-.12-.953h-2.904V15.59c0 1.256-.856 2.273-2.109 2.273A2.27 2.27 0 0 1 8.4 15.59a2.27 2.27 0 0 1 2.268-2.273c.25 0 .332.04.557.115v-2.937c-.234-.034-.314-.05-.557-.05a5.14 5.14 0 0 0-5.132 5.145 5.139 5.139 0 0 0 5.132 5.145c2.795 0 5.149-2.239 5.212-5.025v-5.572c1.054.722 2.248 1.144 3.62 1.144V8.53a3.822 3.822 0 0 1-3.7-2.875z" fill="#fff"/><path d="M8.633 16.597a2.27 2.27 0 0 1 2.034-3.28c.218 0 .308.03.476.088l.081.028v-2.938l-.087-.013c-.171-.024-.26-.037-.47-.037-.16 0-.32.007-.477.022v1.931l-.081-.027a1.189 1.189 0 0 0-.476-.089 2.275 2.275 0 0 0-1 4.315zM6.562 18.68a5.121 5.121 0 0 0 4.105 2.057c2.795 0 5.149-2.24 5.213-5.026v-5.572c1.053.723 2.248 1.145 3.62 1.145V8.53a3.8 3.8 0 0 1-1.034-.142v1.86c-1.373 0-2.568-.422-3.621-1.144v5.572c-.064 2.786-2.418 5.025-5.212 5.025a5.102 5.102 0 0 1-3.071-1.022zm9.773-11.834a3.836 3.836 0 0 1-1.548-2.144h.894a3.815 3.815 0 0 0 .654 2.144z" fill="#fe2c55"/></g></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconTiktok',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
